// Brand helpers shared by the React app, scripts/generate-seo.mjs and the
// backend (server/brand.js). No imports on purpose: the build script and the
// server load this file directly.

const isPlainObject = (v) => v && typeof v === "object" && !Array.isArray(v);
const isEmpty = (v) => v === undefined || v === null || v === "";

/* Combine saved brand settings with a base. Empty values in the override
   ("" / null) keep the base value; nested groups (address, social, colors)
   merge key by key. */
export function mergeBrand(base, override) {
  const out = { ...base };
  if (!isPlainObject(override)) return out;
  for (const [key, value] of Object.entries(override)) {
    if (isPlainObject(value) && isPlainObject(base[key])) {
      out[key] = mergeBrand(base[key], value);
    } else if (!isEmpty(value)) {
      out[key] = value;
    }
  }
  return out;
}

const blank = (v) =>
  isPlainObject(v) ? Object.fromEntries(Object.entries(v).map(([k, x]) => [k, blank(x)])) : typeof v === "number" ? null : "";

/* What a tenant's saved settings are merged onto. The default tenant (this
   site) falls back to defaultBrand.json; any other tenant starts blank so it
   can never show this site's name, phone or address by accident. */
export function baseBrand(defaults, slug) {
  if (!slug || slug === defaults.slug) return defaults;
  return {
    ...blank(defaults),
    slug,
    tagline: defaults.tagline,
    hours: defaults.hours,
    address: { ...blank(defaults.address), addressCountry: defaults.address.addressCountry },
  };
}

/* The full brand for a tenant: base for its slug + its saved settings. */
export function resolveBrand(defaults, slug, saved) {
  return { ...mergeBrand(baseBrand(defaults, slug), saved), slug: slug || defaults.slug };
}
